/**
 * @file Layout header
 * @author zhangyou
 */
import React, { useRef } from 'react'
import styled, { withTheme } from 'styled-components'
import Icon from '../tntd-icon'
import Actions from './HeaderActions'
import AppList from './AppList'
import OrgAppList from './OrgAppList'

const Header = styled.div`
  position: relative;
  z-index: 201;
  height: ${(props) => `${props.theme.headerHeight}px`};
  display: flex;
  color: rgba(255, 255, 255, 0.85);
  background: #fff;
  .hasHeaderTabs & {
    // background: #191D29;
    background: #fff !important;
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.18);
    .tnt-layout-header-content {
      display: none;
    }
  }

  // .tnt-themeS3.hasHeaderTabs &{
  //     background: ${(props) => `${props.theme.blueBgColor} !important`}; //#1D4295 !important;
  // }

  .isInIframe.noAppList &,
  .isEmptyLayout & {
    display: none;
  }
  .tnt-themeS1 & {
    background: #ffffff;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.15);
  }
  .tnt-themeS1.compatible & {
    /* background: #323b4a; */
  }
  padding-right: 20px;
  background: #ffffff;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
  .compatible & {
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
  }
  transition: box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    -webkit-box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  .sidebar-collapsed-controller {
    text-align: center;
    width: ${(props) => `${props.theme.headerHeight}px`};
    line-height: ${(props) => `${props.theme.headerHeight}px`};
    height: ${(props) => `${props.theme.headerHeight}px`};
    cursor: pointer;
    color: ${(props) => `${props.theme.primaryTextColor}`};
    margin-right: 10px;

    & > .tnt-icon {
      font-size: 16px;
      .large-size & {
        font-size: 20px;
      }
    }

    i {
      position: relative;
      top: -1px;
      vertical-align: sub;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.06);
    }

    .tnt-themeS1 & {
      /* color: rgba(255,255,255,.85); */
      color: ${(props) => `${props.theme.primaryTextColor}`};
    }
    .large-size & {
      font-size: 18px;
    }
    .isInIframe & {
      display: none;
    }
  }
`

const Content = styled.div`
  flex: 1;
  .isInIframe & {
    display: none;
  }
`

export default withTheme((props) => {
  const {
    collapsed,
    collapseIconPlacement = 'right',
    selectedAppKey,
    appList, // 当前机构下的应用列表
    orgAppShow, // 是否展示应用
    orgAppList, // 指定机构下的应用列表
    orgTreeConfig, // 机构tree
    selectedOrgKey,
    orgList,
    headerTabs,
    onAppChange,
    onOrgChange,
    onCollapseChange,
    extraActions,
  } = props
  const headerRef = useRef()
  return (
    <Header className="tnt-layout-header" ref={headerRef}>
      {collapseIconPlacement === 'right' && (
        <div className="sidebar-collapsed-controller" onClick={onCollapseChange}>
          <Icon type={`menu-${collapsed ? 'unfold' : 'fold'}`} />
        </div>
      )}
      {headerTabs}

      {/* 展示机构+应用 */}
      {orgList && (
        <OrgAppList
          orgAppShow={orgAppShow}
          selectedOrgKey={selectedOrgKey}
          orgList={orgList}
          selectedAppKey={selectedAppKey}
          onOrgChange={onOrgChange}
          orgTreeConfig={orgTreeConfig}
          orgAppList={orgAppList}
          onAppChange={onAppChange}
          headerTabs={headerTabs}
        />
      )}

      {/* 只展示应用 走老逻辑 */}
      {appList && !orgList && (
        <AppList items={appList} selectedKey={selectedAppKey} onChange={onAppChange} />
      )}
      <Content className="tnt-layout-header-content">{props.children}</Content>
      <Actions {...props} headerRef={headerRef}>
        {extraActions}
      </Actions>
    </Header>
  )
})
